import api from './api';

export interface User {
  id: string;
  username: string;
  email: string;
  role: 'DEALER' | 'ADMIN';
}

export interface LoginResponse {
  token: string;
  user: User;
}

export const login = async (username: string, password: string): Promise<LoginResponse> => {
  const response = await api.post<LoginResponse>('/auth/login', {
    username,
    password,
  });
  return response.data;
};

export const getCurrentUser = async (): Promise<User> => {
  const response = await api.get<User>('/auth/me');
  return response.data;
};

export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};

export const isAuthenticated = (): boolean => {
  return !!localStorage.getItem('token');
};

export const getUser = (): User | null => {
  const userStr = localStorage.getItem('user');
  if (userStr) {
    try {
      return JSON.parse(userStr);
    } catch {
      return null;
    }
  }
  return null;
};

export const isAdmin = (): boolean => {
  const user = getUser();
  return user?.role === 'ADMIN';
};

export interface VerifyEmailResponse {
  success: boolean;
  message: string;
}

export const verifyEmail = async (token: string): Promise<VerifyEmailResponse> => {
  const response = await api.get<VerifyEmailResponse>('/auth/verify-email', {
    params: { token },
  });
  return response.data;
};

export interface ForgotPasswordResponse {
  success: boolean;
  message: string;
}

export const forgotPassword = async (email: string): Promise<ForgotPasswordResponse> => {
  const response = await api.post<ForgotPasswordResponse>('/auth/forgot-password', {
    email,
  });
  return response.data;
};

export interface ResetPasswordResponse {
  success: boolean;
  message: string;
}

export const resetPassword = async (
  token: string,
  password: string
): Promise<ResetPasswordResponse> => {
  const response = await api.post<ResetPasswordResponse>('/auth/reset-password', {
    token,
    password,
  });
  return response.data;
};

export interface VerifyResetTokenResponse {
  success: boolean;
  message: string;
}

export const verifyResetToken = async (token: string): Promise<VerifyResetTokenResponse> => {
  const response = await api.get<VerifyResetTokenResponse>('/auth/verify-reset-token', {
    params: { token },
  });
  return response.data;
};
